import React, { createContext, useState } from "react";

import PropTypes from "prop-types";

export const EntitiesContext = createContext();

export const EntitiesProvider = ({children}) => {
	const [clients, setClients] = useState([]);
	const [suppliers, setSuppliers] = useState([]);
			
	return (
		<EntitiesContext.Provider value={{clients, setClients, suppliers, setSuppliers}}>
			{children}
		</EntitiesContext.Provider>
	);
};

EntitiesProvider.propTypes = {
	children: PropTypes.node.isRequired,
};